// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NUuieCQnOzmop_ukYV1M {
    margin-bottom: 8px;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/components/Summary/SummaryItem/SummaryItem.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".wrapper {\n    margin-bottom: 8px;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `NUuieCQnOzmop_ukYV1M`
};
export default ___CSS_LOADER_EXPORT___;
